// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"0336c573","703":"5b6ac0d6","787":"5e9e9787"}[chunkId] + ".chunk.js";
};